import { formatTaxCents, formatTaxRate, quoteSubscriptionTax, SubscriptionTaxRate } from '../../lib/subscriptionTax';

export default function SubscriptionTaxPreview({
  amount,
  rates,
}: {
  amount: string;
  rates: SubscriptionTaxRate[];
}) {
  const parsed = parseFloat(amount);
  if (!amount || !Number.isFinite(parsed) || parsed <= 0 || rates.length === 0) return null;
  const quote = quoteSubscriptionTax(parsed, rates);
  if (quote.taxCents <= 0) return null;

  return (
    <div className="mt-2 rounded-xl bg-gray-50 border border-gray-200 px-3 py-2.5 space-y-1">
      <div className="flex justify-between text-xs text-gray-500">
        <span>Amount</span>
        <span>${formatTaxCents(quote.netCents)}</span>
      </div>
      {quote.lines.map((line) => (
        <div key={`${line.name}-${line.rate}`} className="flex justify-between text-xs text-gray-500">
          <span>{line.name} ({formatTaxRate(line.rate)}%)</span>
          <span>${formatTaxCents(line.amountCents)}</span>
        </div>
      ))}
      <div className="flex justify-between text-sm font-semibold text-gray-900 pt-1 border-t border-gray-200">
        <span>Customer pays</span>
        <span>${formatTaxCents(quote.totalCents)}</span>
      </div>
    </div>
  );
}
